import { getMessages } from '../../../../../../../store/constants';

export const CARD_ICON_ARCHIVED = getMessages().getText('card_form_icon_archived');
